import AdminCRUD from "@/components/admin/AdminCRUD";

const empty = { name: "", role: "", image_path: "", memory_name: "", memory_relation: "", memory_image_path: "", bio: "", order: 0 };
const fields = [
  { name: "name", label: "Leader name", type: "text", required: true, placeholder: "e.g. Wesley Bal" },
  { name: "role", label: "Role / Title", type: "text", placeholder: "e.g. President" },
  { name: "image_path", label: "Leader photo", type: "image" },
  { name: "bio", label: "Bio", type: "textarea", rows: 6, placeholder: "Their story..." },
  { name: "memory_name", label: "In loving memory of - name", type: "text", placeholder: "e.g. Rachel Amber" },
  { name: "memory_relation", label: "In loving memory of - relation", type: "text", placeholder: "e.g. Daughter" },
  { name: "memory_image_path", label: "In loving memory of - photo", type: "image" },
];

export default function AdminLeaders() {
  return (
    <AdminCRUD
      title="Leaders"
      description="The Our Leaders section on the About page. Use the up/down arrows to reorder."
      endpoint="leaders"
      emptyItem={empty}
      fields={fields}
      itemLabel={(l) => l.name || "(no name)"}
      itemSubtitle={(l) => l.role + (l.memory_name ? ` · in memory of ${l.memory_name}` : "")}
    />
  );
}
